import React, { useContext } from 'react';
import { useHelmet, RedirectTag } from '@thd-nucleus/thd-helmet';
import proptypes from 'prop-types';
const { string } = proptypes;
import {
  params,
  string as stringType,
  json,
  useDataModel
} from '@thd-nucleus/data-sources';
import { RedirectContext } from './RedirectContext';
import { handleErrors, ERROR_HANDLING_EXPERIENCE } from '../utils/redirector-utils';
import { notFoundHandler } from './rules/local-city-rules';

const localCityHandler = ({ data, error: err, props }) => {
  const errors = handleErrors(err, ERROR_HANDLING_EXPERIENCE.GENERIC);
  if (errors) {
    return new RedirectTag(errors, props.bypass);
  }

  const notFound = notFoundHandler({ data, guid: props.guid });
  if (notFound) {
    return new RedirectTag(notFound, props.bypass);
  }

  return null;
};

export const LocalCityRedirector = ({ guid }) => {
  const { pathWithQueryParams, bypass } = useContext(RedirectContext);

  const [path] = pathWithQueryParams?.split('?') || '';

  const emtContentOpts = {
    variables: {
      contentId: guid,
      pageName: 'lcp'
    },
    skip: !guid
  };
  const { data, error } = useDataModel('emtContent', emtContentOpts);

  const handlerProps = {
    path,
    guid,
    bypass
  };

  useHelmet('localCityRedirector',
    { data, error, props: handlerProps },
    localCityHandler,
    [guid]
  );

  return null;
};

LocalCityRedirector.displayName = 'LocalCityRedirector';

LocalCityRedirector.propTypes = {
  guid: string.isRequired
};

LocalCityRedirector.dataModel = {
  emtContent: params({
    contentId: stringType().isRequired(),
    pageName: stringType().isRequired()
  }).shape({
    content: json()
  }),
};
